import { checkImportExact, clearExistingScheduledImports} from './import';
import { enableUpdateImports, getCurrentUser, updateUserLastAction, handleStatus} from './utils';
// Handles exactonline import execution on the server
export async function handleImport(row, updateStatus){
  // await checkImportExact(data[id].entiteit, data[id].year, data[id].budget_scenario, office);
  try {
    handleStatus(updateStatus, 'exactonline', true);
    const response = await fetch('/exactonline/executeImport', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json' 
      },
      body: JSON.stringify({
        entiteit: row.entiteit,
        year: row.year,
        budget_scenario: row.budget_scenario,
        office: row.office,
        user_id: await getCurrentUser(),
      }),
    });
    if (response.ok) {
      // const responseData = await response.json();  
      // return responseData;
      await enableUpdateImports();
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

//Submits import exact updates/changes
export async function updateImportExact(id, openingBalance, ignoreYearEnd){
  try{
    const response = await fetch('/import_exact/updateImportExact', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: id,
        openingBalance: openingBalance,
        ignoreYearEnd: ignoreYearEnd,
      }),
    })
    if (response.ok) {
      console.log(responseData);
      const responseData = await response.json();
      return responseData;
    }
  } catch (error) {
    console.error('Error fetching data:', error);
  }
}

// Delete import exact by id
export async function deleteImportExact(id){
  try { 
    // var importData = data.filter(item => item.id == id)[0];
    const importResponse = await fetch('/import_exact/getById?id='+id);
    if(importResponse.ok){
      const importData = await importResponse.json();

      await clearExistingScheduledImports({"import_type": "exactonline", "entiteit": importData["entiteit"], "year": importData["year"],"office": importData["office"], "budget_scenario": importData["budget_scenario"]})
    
      const response = await fetch('/import_exact/deleteImportExact?id='+id);
      if (response.ok) {
      const responseData = await response.json();
      
      if(responseData){
      }
    }
    
  }
  } catch (error) {
    console.error('Error deleting data:', error);
  }
}


